import React from "react";
import Post from "../../components/case-studies/post";
import Testimonial from "../../components/testimonial/Testimonial";
import { NextSeo } from 'next-seo';
import { client } from "../../utils/createApolloClient";
import {
  CreateEnquiryDocument,
  PostListingDocument,
  useCompanyListingQuery,
  useEnquiryCategoryListingQuery
} from '../../graphql/api';
import ContactForm from '../../components/careers/contactForm';
import { toast } from 'react-toastify';

const CareerDetail = ({ post_slug = null, data = null }) => {
  const metaTitle = `${data?.attributes?.post_title ?? post_slug} - Alchemis`;
  const metaDesc = data?.attributes?.post_short_description ?? '';
  const metaImg = `/images/meta/general.png`;

  const { data: companyListingData } = useCompanyListingQuery({
    variables: {
      filters: {
        slug: {
          eq: "alchemis"
        }
      }
    }
  });

  const { data: enquiryCategoryListingData } = useEnquiryCategoryListingQuery({
    variables: {
      filters: {
        enquiry_category_slug: {
          eq: `job-enquiry`
        }
      }
    }
  });

  const handleSubmitRegister = async (e) => {
    const company = companyListingData?.companies?.data?.length > 0 ? companyListingData?.companies?.data[0] : null;
    const enquiry_category = enquiryCategoryListingData?.enquiryCategories?.data?.length > 0 ? enquiryCategoryListingData?.enquiryCategories?.data[0] : null;

    if (company?.id && enquiry_category?.id) {
      const prepare_card_input = {
        enquiry_name: e?.name,
        enquiry_email: e?.email,
        enquiry_mobile: e?.phone,
        enquiry_message: e?.message,
        enquiry_link: e?.portfolio,
        enquiry_category: enquiry_category?.id,
        post: data?.id,
        company: company?.id,
        enquiry_media: e?.media,
        publishedAt: new Date(),
      };

      await client
        .mutate({
          mutation: CreateEnquiryDocument,
          variables: {
            data: prepare_card_input,
          },
          errorPolicy: "all",
        })
        .then((res) => {
          console.log({ 'post - prepare_card_input': res });
          toast.success('Successfully Submit!');
        });
    }
  }

  return (
    <div>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <Post title={data?.attributes?.post_title} content={data?.attributes?.post_description} />
      <ContactForm onSubmit={handleSubmitRegister}/>
      {/* <Testimonial bg_jacerta={true} /> */}
    </div>
  );
};

export async function getStaticPaths() {
  const { data } = await client.query({
    query: PostListingDocument,
    variables: {
      filters: {
        companies: {
          slug: {
            eq: "alchemis"
          }
        },
        post_type: {
          post_type_slug: {
            eq: "career"
          }
        }
      }
    },
  });
  const paths = data?.posts?.data?.map((post) => ({
    params: {
      slug: post?.attributes?.post_slug,
    },
  }));

  return {
    paths,
    fallback: false,
  };
}

export const getStaticProps = async ({ params }) => {
  const post_slug = params?.slug ?? '';

  const post_listing_query = client.query({
    query: PostListingDocument,
    variables: {
      filters: {
        post_slug: {
          eq: post_slug,
        },
        companies: {
          slug: {
            eq: "alchemis"
          }
        },
        post_type: {
          post_type_slug: {
            eq: "career"
          }
        }
      }
    },
  })
  const responses = await Promise.all([post_listing_query]);

  return {
    props: {
      post_slug: post_slug,
      data: responses[0]?.data?.posts?.data[0]
    },
  };
}

export default CareerDetail;
